import { useState } from "react";
import { faqs } from "@/mocks/homeData";

const trust = [
  { icon: "ri-refresh-line", title: "按周持续更新", desc: "合集与大全随热点与新进展滚动补充。" },
  { icon: "ri-focus-3-line", title: "多来源交叉归纳", desc: "以公开声明、报道与节目口径为基础整理。" },
  { icon: "ri-shield-check-line", title: "标注信息类型", desc: "每条归档会注明声明 / 报道 / 考古等来源。" },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="border-t border-ink/10 bg-paper/60">
      <div className="shell-wrap py-14 md:py-20">
        {/* trust band */}
        <div className="grid gap-4 md:grid-cols-3">
          {trust.map((t) => (
            <div key={t.title} className="flex items-start gap-4 rounded-2xl border border-ink/10 bg-paper p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ember/10 text-xl text-ember">
                <i className={t.icon} />
              </span>
              <div>
                <h3 className="title-serif text-base font-black">{t.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-ink/60">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* faq */}
        <div className="mt-12 grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
          <div>
            <p className="section-eyebrow">
              <i className="ri-question-answer-line" /> 常见问题
            </p>
            <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">
              使用前先读这几条
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-ink/65 md:text-base">
              关于站内口径、更新节奏、来源与转载规则，说明清楚后再按需查阅更顺畅。
            </p>
          </div>

          <div className="divide-y divide-ink/10 rounded-2xl border border-ink/10 bg-paper">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="title-serif text-sm font-black md:text-base">
                      <span className="mr-2 text-ember">{String(i + 1).padStart(2, "0")}</span>
                      {f.q}
                    </span>
                    <span
                      className={
                        "flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-ember transition-transform " +
                        (open ? "rotate-45 border-ember bg-ember text-white" : "border-ink/20")
                      }
                    >
                      <i className="ri-add-line" />
                    </span>
                  </button>
                  {open && (
                    <p className="anchor-panel px-5 pb-5 text-sm leading-relaxed text-ink/65 md:pl-12">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}